type ChangePasswordError = {
  doesNotHaveUpper: boolean;
  doesNotHaveNumberOrSpecialChar: boolean;
  isTooShort: boolean;
  mismatchedConfirmation: boolean;
  wrongPassword: boolean;
};

const changePasswordError: ChangePasswordError = {
  doesNotHaveNumberOrSpecialChar: false,
  doesNotHaveUpper: false,
  isTooShort: false,
  mismatchedConfirmation: false,
  wrongPassword: false,
};

export type { ChangePasswordError };

export { changePasswordError };
